import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSpinner = () => {
    return (_jsx("div", { className: "grid h-screen place-items-center", children: _jsx("div", { className: "loader" }) }));
};
export default LoadingSpinner;
